import React from 'react'
import PropTypes from 'prop-types'

import FormattedMessage from './FormattedMessage'
import FormattedHTMLMessage from './FormattedHTMLMessage'
import intlMessageShape from './intlMessageShape'


const Message = ({ text, html, tag, messageName, dataTestId, ...rest }) => {
  if (!text) {
    return null
  }

  const isIntlMessage = typeof text === 'object'

  if (isIntlMessage) {
    const element = html ? FormattedHTMLMessage : FormattedMessage
    const { id: tagId } = rest

    return React.createElement(element, {
      tag,
      tagId,
      name: messageName,
      dataTestId,
      ...rest,
      ...text,
    }) // rest should be first coz there can be "values: undefined"
  }

  if (!html) {
    return React.createElement(tag, { ...rest, 'data-testid': dataTestId }, text)
  }

  return (
    React.createElement(tag, {
      dangerouslySetInnerHTML: { __html: text },
      ...rest,
      'data-testid': dataTestId,
    })
  )
}

Message.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  tag: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(intlMessageShape),
  ]),
  messageName: PropTypes.string,
  html: PropTypes.bool,
}

Message.defaultProps = {
  html: false,
  tag: 'span',
}


export default Message
